<div class="container">
  <mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="guiService.goTo('main/home')">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
  <h2 class="workout-programs-title">{{"WORKOUT-PROGRAMS.TITLE" | translate}}</h2>

  <!-- PROGRAMMI VISIBILI -->
  <div class="programs-container" *ngIf="!guiService.showSkeleton">
    <div
      class="program"
      *ngFor="let program of guiService.programs; let i = index"
      [class.current-program]="program.id === guiService?.userLogged?.workoutInfo?.currentProgram"
      (click)="openModalProgramDetail(program, guiService.evaluateBgColor(i))">
      <img [src]="environment + '/' + program.id + '/images/main'" alt="Program image">
    </div>
  </div>

  <!-- SKELETON -->
  <div class="programs-container" *ngIf="guiService.showSkeleton">
    <div class="program skeleton" *ngFor="let skel of [1,2,3,4,5]"></div>
  </div>
</div>
